/**
 * Configuration for subcategory detection across all expense categories
 */
import type { ExpenseCategory } from '../types';

export interface SubcategoryDetectionConfig {
  categoryName: ExpenseCategory;
  overrideThreshold: number;
  useThreshold: number;
}

export const SUBCATEGORY_CONFIGS: SubcategoryDetectionConfig[] = [
  // Healthcare - checked first, higher threshold to prevent false positives
  {
    categoryName: 'healthcare',
    overrideThreshold: 0.65,
    useThreshold: 0.35,
  },
  // Drinks before food: an exact drinks/food tie is a drink phrase naming
  // its ingredient ("suco de laranja", "orange juice"), so drinks should
  // own the provisional chip while the cloud breaks the tie.
  {
    categoryName: 'drinks',
    overrideThreshold: 0.65,
    useThreshold: 0.35,
  },
  // Food - checked early as food keywords are common and distinctive
  {
    categoryName: 'food',
    overrideThreshold: 0.65,
    useThreshold: 0.35,
  },
  // Transport - distinctive keywords like uber, taxi, gas
  {
    categoryName: 'transport',
    overrideThreshold: 0.6,
    useThreshold: 0.35,
  },
  // Accommodation - clear keywords like hotel, airbnb, rent
  {
    categoryName: 'accommodation',
    overrideThreshold: 0.65,
    useThreshold: 0.4,
  },
  // Entertainment - balance between streaming services and activities
  {
    categoryName: 'entertainment',
    overrideThreshold: 0.6,
    useThreshold: 0.35,
  },
  // Shopping - higher threshold to avoid confusion with other purchases
  {
    categoryName: 'shopping',
    overrideThreshold: 0.65,
    useThreshold: 0.4,
  },
  // Utilities - high threshold for utility services
  {
    categoryName: 'utilities',
    overrideThreshold: 0.6,
    useThreshold: 0.35,
  },
];
